import React, { useEffect, useState } from "react";
import { NavLink, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import "../Login/login.css";
import swal from "sweetalert";
import { securityQuestions } from "../../constants/constants";
import useInput from "../../hooks/use-input";
import Select from "react-select";
import {
  currentCareSiteDataHandler,
  currentCareSiteIdHandler,
  currentCareSiteTokenHandler,
} from "../../redux-toolkit/reducer/switchSites";
import {
  setAccessTokenExpiry,
  setRefreshToken,
} from "../../redux-toolkit/reducer/refreshToken_reducer";
import { useDispatch } from "react-redux";

const isEmpty = (value) => value.trim() !== "";

function SecurityQuestion() {
  //security questions
  let history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  const [question, setQuestion] = useState("");

  const {
    value: securityAnswerValue,
    isValid: securityAnswerIsValid,
    hasError: securityAnswerHasError,
    valueChangeHandler: securityAnswerChangeHandler,
    inputBlurHandler: securityAnswerBlurHandler,
  } = useInput(isEmpty);

  const securityAnswerClasses = securityAnswerHasError
    ? "form-control invalid"
    : "form-control";

  const isFormValidCheck = () => {
    if (securityAnswerIsValid && question !== "") {
    }
  };

  function checkSecurityQuestions() {
    let data = JSON.stringify({
      userId: params.id,
      panel: "admin",
      question: question,
      answer: securityAnswerValue,
    });

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/checkSecurityQuestions`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        if (response.data.status === true) {
          swal("Success", response.data?.message, "success").then((value) => {
            handleRefreshToken(response.data);
            history.push("/dashboard");
          });
        } else {
          swal("failed", response.data.message, "error").then((value) => {
            return;
          });
        }
      })
      .catch(function (error) {
        console.log(error, "error");
      });
  }

  const handleRefreshToken = (response) => {
    localStorage.removeItem("care_admin_token");
    console.log(response, "security questiion response---------");

    // Ensure we're setting a real token, not a placeholder
    if (response?.token) {
      localStorage.setItem("care_admin_token", response?.token);
    }
    dispatch(
      currentCareSiteIdHandler({
        currentCareSiteId: response?.data?.defaultCareSiteId,
        status: "login",
        loginData: response?.data,
      })
    );
    dispatch(
      currentCareSiteTokenHandler({
        care_admin_token: response?.token,
      })
    );
    dispatch(
      currentCareSiteDataHandler({
        userData: response?.data,
      })
    );

    // Save refresh token to Redux store
    if (response?.refreshToken) {
      //console.log('[Login] Saving refresh token to Redux store');
      dispatch(
        setRefreshToken({
          refreshToken: response?.refreshToken,
        })
      );
    }

    // Save access token expiry to Redux store
    if (response?.token) {
      dispatch(
        setAccessTokenExpiry({
          accessToken: response?.token,
        })
      );
    }
  };

  function selectQuestion(event) {
    setQuestion(event.label);
  }

  return (
    <section className="login_section">
      <div className="login_header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 logo_box">
              <NavLink className="navbar-brand" to="/dashboard">
                <b className="logo-icon">
                  <img alt="" src={`/admin/images/logo.svg`} />
                </b>
              </NavLink>
            </div>
            <div className="col-md-9">
              <div className="login_title">
                <h1>Care Management Simplified!</h1>
                <p>
                  Welcome to your new experience of care management. Our
                  powerful, easy to use <br /> and intuitive care platform,
                  enables you to easily manage all you care tasks.
                </p>
              </div>
            </div>
            <div className="col-md-3 img_box">
              <img alt="" src={`/admin/images/login.svg`} />
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 form_box">
        <form>
          <h4>Security Questions</h4>
          <Select
            options={securityQuestions}
            onChange={selectQuestion}
            required={true}
          />
          {question !== "" && (
            <input
              style={{ marginTop: "20px" }}
              type="text"
              id="securityAnswer"
              value={securityAnswerValue}
              onChange={securityAnswerChangeHandler}
              onBlur={securityAnswerBlurHandler}
              className={securityAnswerClasses}
              placeholder="Security Answer"
            />
          )}{" "}
          {securityAnswerHasError && (
            <span className="input_error">Please Enter Security Answer</span>
          )}
          <NavLink to="/forgot-securityquestion" className="forgot">
            Forgot Security Question?
          </NavLink>
          <button
            type="button"
            onClick={checkSecurityQuestions}
            className="form-control btn"
          >
            Log in
          </button>
        </form>
      </div>
    </section>
  );
}

export default SecurityQuestion;
